var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible
    ? _c(
        "div",
        [
          _c(
            "el-dialog",
            {
              class: ["base-dialog", _vm.commClass],
              attrs: {
                visible: _vm.visible,
                title: _vm.title,
                width: _vm.width,
                top: _vm.top,
                "before-close": _vm.handleClose,
                "close-on-click-modal": _vm.closeOnModal,
                "close-on-press-escape": false,
                "destroy-on-close": _vm.destroyOnClose,
                "append-to-body": "",
              },
            },
            [
              !_vm.closeOnModal
                ? _c(
                    "div",
                    {
                      staticClass: "basic-dialog-title",
                      attrs: { slot: "title" },
                      slot: "title",
                    },
                    [
                      _c("span", [_vm._v(_vm._s(_vm.title))]),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "close-icon",
                        attrs: { src: require("@/static/img/close-icon.png") },
                        on: { click: _vm.handleClose },
                      }),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._t("default"),
            ],
            2
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }